import React from 'react'
import Button from '@mui/material/Button'
import { IQDialog } from '../../common'

interface IProps {
  title?: string
  content: string | React.ReactNode
  dataTestId?: string
  isShow: boolean
  onClose: () => void
  onCancel: () => void
}

export const CancelAlert = ({ title, content, dataTestId, isShow, onClose, onCancel }: IProps) => (
  <IQDialog
    isShow={isShow}
    title={title || ''}
    content={content}
    actions={
      <Button
        variant='contained'
        onClick={onCancel}
        data-testid={`${dataTestId}-cancel-ok`}
      >
        OK
      </Button>
    }
    onClose={onClose}
    testPrefix={`${dataTestId}-cancel`}
  />
)
